import { Toast } from "../../../../components/Common/Toast";
import { callAPI } from "../../../../services/api.service";
import { VideoLinks } from "../TrainingVideos";

// Service function to get training videos
export const getTrainingVideosService = async () => {
    try {
        const data = await callAPI(`admin/settings/getTrainingVideos`);
        return data?.links || [];
    } catch (error) {
        Toast("Something went wrong!", true);
        throw new Error("Error fetching training videos");
    }
};

// Service function to update training videos
export const updateTrainingVideosService = async (TrainingVideos: any) => {
    try {
        const response = await callAPI(`admin/settings/updateTrainingVideos`, { TrainingVideos });
        return response;
    } catch (error) {
        throw new Error("Something went wrong while updating training videos");
    }
};

export const validateTrainingVideos = async (trainingVideos: VideoLinks) => {
    const YOUTUBE_REGEX = /^https:\/\/www\.youtube\.com\/embed\/[\w-]+(\?.*)?$/;

    const allowedKeys = [
        "STORY_CHARCTER_BUILDER_VIDEO",
        "STORY_EDITOR_VIDEO",
        "STORY_INTRO_VIDEO",
        "STORY_PURCHASE_AND_VIEW_VIDEO",
    ];

    for (const [key, url] of Object.entries(trainingVideos)) {
        if (!allowedKeys?.includes(key)) {
            return { valid: false, message: `Invalid key: ${key}` };
        }
        if (!YOUTUBE_REGEX.test(url as string)) {
            return { valid: false, message: `Invalid YouTube URL for key: ${key}` };
        }
    }

    return { valid: true, message: "Validation passed" };
};
